import {
    Directive,
    HostListener,
    ElementRef,
    OnInit,
    Injector
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appThousandSeparator]'
})
export class ThousandSeparatorDirective implements OnInit {
    private control!: NgControl['control'];

    constructor(
        private el: ElementRef<HTMLInputElement>,
        private injector: Injector
    ) { }

    ngOnInit(): void {
        const ngControl = this.injector.get(NgControl, null, { self: true, optional: true });
        if (!ngControl?.control) {
            throw new Error('appThousandSeparator must be used with formControl/formControlName');
        }
        this.control = ngControl.control;
    }

    @HostListener('input')
    onInput(): void {
        const inputValue = this.el.nativeElement.value.replace(/,/g, '');
        if (!isNaN(Number(inputValue))) {
            this.control!.setValue(+inputValue, { emitEvent: false });
            this.el.nativeElement.value = Number(inputValue)
                .toLocaleString('en-US');
        } else {
            const value = this.control!.value.replace(/\D/g, '');
            this.control!.setValue(value);
            this.el.nativeElement.value = Number(value)
                .toLocaleString('en-US');
        }
    }
}
